/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbrirDiscussaoDto,
  AnexoEnviadoResponse,
  ArtigoResponse,
  AtualizarRascunhoDiscussaoDto,
  AvaliarDiscussaoDto,
  CriarExameExternoDto,
  CriarRascunhoDiscussaoDto,
  DiscussaoResponse,
  DiscussoesControllerEnviarAnexoBody,
  DiscussoesControllerEnviarMensagemDeVozBody,
  DiscussoesControllerListarEspecialidadesParams,
  DiscussoesControllerListarMensagensParams,
  DiscussoesControllerListarParams,
  DiscussoesControllerObterLinhaDoTempoDoHistoricoParams,
  EnviarMensagemDto,
  ErroResponse,
  ExameExternoResponse,
  ExameResponse,
  LinhaDoTempoResponse,
  ListaDeAdvisorsDisponiveisResponse,
  ListaDeAdvisorsResumoResponse,
  ListaDeArtigosResponse,
  ListaDeEspecialidadesResponse,
  MelhorarTextoDto,
  MensagemResponse,
  PacienteDaDiscussaoResponse,
  PaginaDeDiscussoesResponse,
  PaginaDeMensagensResponse,
  RascunhoDiscussaoResponse,
  ResumoDaDiscussaoResponse,
  ResumoDoHistoricoResponse,
  SerieDoAnalitoResponse,
  TextoMelhoradoResponse,
  UrlDoArquivoResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getDiscussoesControllerAdvisorsDisponiveisUrl = () => {




  return `/v1/discussoes/advisors-disponiveis`
}

/**
 * @summary Advisors com vaga agora, para escolher ao abrir uma discussão
 */
export const discussoesControllerAdvisorsDisponiveis = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeAdvisorsDisponiveisResponse> => {

  return httpClient<ListaDeAdvisorsDisponiveisResponse>(getDiscussoesControllerAdvisorsDisponiveisUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerAdvisorsDisponiveisQueryKey = () => {
    return [
    `/v1/discussoes/advisors-disponiveis`
    ] as const;
    }


export const getDiscussoesControllerAdvisorsDisponiveisQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerAdvisorsDisponiveisQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>> = ({ signal }) => discussoesControllerAdvisorsDisponiveis({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerAdvisorsDisponiveisQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>>
export type DiscussoesControllerAdvisorsDisponiveisQueryError = unknown


export function useDiscussoesControllerAdvisorsDisponiveis<TData = Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerAdvisorsDisponiveis<TData = Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerAdvisorsDisponiveis<TData = Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Advisors com vaga agora, para escolher ao abrir uma discussão
 */

export function useDiscussoesControllerAdvisorsDisponiveis<TData = Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisorsDisponiveis>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerAdvisorsDisponiveisQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerAdvisorsUrl = () => {




  return `/v1/discussoes/advisors`
}

/**
 * @summary Todos os advisors ativos, com indicação de disponibilidade hoje — para o passo informativo antes de abrir uma discussão
 */
export const discussoesControllerAdvisors = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeAdvisorsResumoResponse> => {

  return httpClient<ListaDeAdvisorsResumoResponse>(getDiscussoesControllerAdvisorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerAdvisorsQueryKey = () => {
    return [
    `/v1/discussoes/advisors`
    ] as const;
    }


export const getDiscussoesControllerAdvisorsQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerAdvisorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerAdvisors>>> = ({ signal }) => discussoesControllerAdvisors({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerAdvisorsQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerAdvisors>>>
export type DiscussoesControllerAdvisorsQueryError = unknown


export function useDiscussoesControllerAdvisors<TData = Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerAdvisors>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerAdvisors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerAdvisors<TData = Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerAdvisors>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerAdvisors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerAdvisors<TData = Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Todos os advisors ativos, com indicação de disponibilidade hoje — para o passo informativo antes de abrir uma discussão
 */

export function useDiscussoesControllerAdvisors<TData = Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerAdvisors>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerAdvisorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerListarEspecialidadesUrl = (params?: DiscussoesControllerListarEspecialidadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/discussoes/especialidades?${stringifiedParams}` : `/v1/discussoes/especialidades`
}

/**
 * @summary Lista as especialidades cadastradas (catálogo global), para o dropdown de abertura
 */
export const discussoesControllerListarEspecialidades = async (params?: DiscussoesControllerListarEspecialidadesParams, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeEspecialidadesResponse> => {

  return httpClient<ListaDeEspecialidadesResponse>(getDiscussoesControllerListarEspecialidadesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerListarEspecialidadesQueryKey = (params?: DiscussoesControllerListarEspecialidadesParams,) => {
    return [
    `/v1/discussoes/especialidades`, ...(params ? [params] : [])
    ] as const;
    }


export const getDiscussoesControllerListarEspecialidadesQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError = unknown>(params?: DiscussoesControllerListarEspecialidadesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerListarEspecialidadesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>> = ({ signal }) => discussoesControllerListarEspecialidades(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerListarEspecialidadesQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>>
export type DiscussoesControllerListarEspecialidadesQueryError = unknown


export function useDiscussoesControllerListarEspecialidades<TData = Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError = unknown>(
 params: undefined |  DiscussoesControllerListarEspecialidadesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerListarEspecialidades<TData = Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError = unknown>(
 params?: DiscussoesControllerListarEspecialidadesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerListarEspecialidades<TData = Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError = unknown>(
 params?: DiscussoesControllerListarEspecialidadesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as especialidades cadastradas (catálogo global), para o dropdown de abertura
 */

export function useDiscussoesControllerListarEspecialidades<TData = Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError = unknown>(
 params?: DiscussoesControllerListarEspecialidadesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarEspecialidades>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerListarEspecialidadesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerCriarExameExternoUrl = () => {




  return `/v1/discussoes/exames-externos`
}

/**
 * @summary Registra no prontuário um exame que veio pronto de fora (sem escolher tipo do catálogo)
 */
export const discussoesControllerCriarExameExterno = async (criarExameExternoDto: CriarExameExternoDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameExternoResponse> => {

  return httpClient<ExameExternoResponse>(getDiscussoesControllerCriarExameExternoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarExameExternoDto)
  }
);}





export const getDiscussoesControllerCriarExameExternoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerCriarExameExterno>>, TError,{data: CriarExameExternoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerCriarExameExterno>>, TError,{data: CriarExameExternoDto}, TContext> => {

const mutationKey = ['discussoesControllerCriarExameExterno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerCriarExameExterno>>, {data: CriarExameExternoDto}> = (props) => {
          const {data} = props ?? {};

          return  discussoesControllerCriarExameExterno(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerCriarExameExternoMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerCriarExameExterno>>>
    export type DiscussoesControllerCriarExameExternoMutationBody = CriarExameExternoDto
    export type DiscussoesControllerCriarExameExternoMutationError = ErroResponse

    /**
 * @summary Registra no prontuário um exame que veio pronto de fora (sem escolher tipo do catálogo)
 */
export const useDiscussoesControllerCriarExameExterno = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerCriarExameExterno>>, TError,{data: CriarExameExternoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerCriarExameExterno>>,
        TError,
        {data: CriarExameExternoDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerCriarExameExternoMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerObterArquivoDoExameUrl = (exameId: string,) => {




  return `/v1/discussoes/exames-externos/${exameId}/arquivo`
}

/**
 * @summary URL assinada do anexo de um exame externo
 */
export const discussoesControllerObterArquivoDoExame = async (exameId: string, options?: Parameters<typeof httpClient>[1]): Promise<UrlDoArquivoResponse> => {

  return httpClient<UrlDoArquivoResponse>(getDiscussoesControllerObterArquivoDoExameUrl(exameId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterArquivoDoExameQueryKey = (exameId: string,) => {
    return [
    `/v1/discussoes/exames-externos/${exameId}/arquivo`
    ] as const;
    }


export const getDiscussoesControllerObterArquivoDoExameQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError = ErroResponse>(exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterArquivoDoExameQueryKey(exameId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>> = ({ signal }) => discussoesControllerObterArquivoDoExame(exameId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: exameId !== null && exameId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterArquivoDoExameQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>>
export type DiscussoesControllerObterArquivoDoExameQueryError = ErroResponse


export function useDiscussoesControllerObterArquivoDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError = ErroResponse>(
 exameId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterArquivoDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError = ErroResponse>(
 exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterArquivoDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError = ErroResponse>(
 exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary URL assinada do anexo de um exame externo
 */

export function useDiscussoesControllerObterArquivoDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError = ErroResponse>(
 exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterArquivoDoExameQueryOptions(exameId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerObterResultadosDoExameUrl = (exameId: string,) => {




  return `/v1/discussoes/exames-compartilhados/${exameId}/resultados`
}

/**
 * @summary Resultados de um exame do catálogo (sem arquivo) compartilhado numa discussão
 */
export const discussoesControllerObterResultadosDoExame = async (exameId: string, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getDiscussoesControllerObterResultadosDoExameUrl(exameId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterResultadosDoExameQueryKey = (exameId: string,) => {
    return [
    `/v1/discussoes/exames-compartilhados/${exameId}/resultados`
    ] as const;
    }


export const getDiscussoesControllerObterResultadosDoExameQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError = ErroResponse>(exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterResultadosDoExameQueryKey(exameId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>> = ({ signal }) => discussoesControllerObterResultadosDoExame(exameId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: exameId !== null && exameId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterResultadosDoExameQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>>
export type DiscussoesControllerObterResultadosDoExameQueryError = ErroResponse


export function useDiscussoesControllerObterResultadosDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError = ErroResponse>(
 exameId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterResultadosDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError = ErroResponse>(
 exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterResultadosDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError = ErroResponse>(
 exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resultados de um exame do catálogo (sem arquivo) compartilhado numa discussão
 */

export function useDiscussoesControllerObterResultadosDoExame<TData = Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError = ErroResponse>(
 exameId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResultadosDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterResultadosDoExameQueryOptions(exameId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerEnviarAnexoUrl = () => {




  return `/v1/discussoes/anexos`
}

/**
 * @summary Envia um anexo solto (exame ainda não cadastrado, laudo em foto...) e devolve o `arquivoId`
 */
export const discussoesControllerEnviarAnexo = async (discussoesControllerEnviarAnexoBody: DiscussoesControllerEnviarAnexoBody, options?: Parameters<typeof httpClient>[1]): Promise<AnexoEnviadoResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, discussoesControllerEnviarAnexoBody.arquivo);

  return httpClient<AnexoEnviadoResponse>(getDiscussoesControllerEnviarAnexoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getDiscussoesControllerEnviarAnexoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarAnexo>>, TError,{data: DiscussoesControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarAnexo>>, TError,{data: DiscussoesControllerEnviarAnexoBody}, TContext> => {

const mutationKey = ['discussoesControllerEnviarAnexo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerEnviarAnexo>>, {data: DiscussoesControllerEnviarAnexoBody}> = (props) => {
          const {data} = props ?? {};

          return  discussoesControllerEnviarAnexo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerEnviarAnexoMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerEnviarAnexo>>>
    export type DiscussoesControllerEnviarAnexoMutationBody = DiscussoesControllerEnviarAnexoBody
    export type DiscussoesControllerEnviarAnexoMutationError = ErroResponse

    /**
 * @summary Envia um anexo solto (exame ainda não cadastrado, laudo em foto...) e devolve o `arquivoId`
 */
export const useDiscussoesControllerEnviarAnexo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarAnexo>>, TError,{data: DiscussoesControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerEnviarAnexo>>,
        TError,
        {data: DiscussoesControllerEnviarAnexoBody},
        TContext
      > => {
      return useMutation(getDiscussoesControllerEnviarAnexoMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerAbrirUrl = () => {




  return `/v1/discussoes`
}

/**
 * @summary Cria o RASCUNHO de uma discussão com o advisor escolhido. Ainda não cobra nada — o pagamento é o próximo passo, em POST /discussoes/:id/pagamento.
 */
export const discussoesControllerAbrir = async (abrirDiscussaoDto: AbrirDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<DiscussaoResponse> => {

  return httpClient<DiscussaoResponse>(getDiscussoesControllerAbrirUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(abrirDiscussaoDto)
  }
);}





export const getDiscussoesControllerAbrirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAbrir>>, TError,{data: AbrirDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAbrir>>, TError,{data: AbrirDiscussaoDto}, TContext> => {

const mutationKey = ['discussoesControllerAbrir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerAbrir>>, {data: AbrirDiscussaoDto}> = (props) => {
          const {data} = props ?? {};

          return  discussoesControllerAbrir(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerAbrirMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerAbrir>>>
    export type DiscussoesControllerAbrirMutationBody = AbrirDiscussaoDto
    export type DiscussoesControllerAbrirMutationError = ErroResponse

    /**
 * @summary Cria o RASCUNHO de uma discussão com o advisor escolhido. Ainda não cobra nada — o pagamento é o próximo passo, em POST /discussoes/:id/pagamento.
 */
export const useDiscussoesControllerAbrir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAbrir>>, TError,{data: AbrirDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerAbrir>>,
        TError,
        {data: AbrirDiscussaoDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerAbrirMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerListarUrl = (params?: DiscussoesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/discussoes?${stringifiedParams}` : `/v1/discussoes`
}

/**
 * @summary Lista as discussões do próprio ambiente
 */
export const discussoesControllerListar = async (params?: DiscussoesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeDiscussoesResponse> => {

  return httpClient<PaginaDeDiscussoesResponse>(getDiscussoesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerListarQueryKey = (params?: DiscussoesControllerListarParams,) => {
    return [
    `/v1/discussoes`, ...(params ? [params] : [])
    ] as const;
    }


export const getDiscussoesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerListar>>, TError = unknown>(params?: DiscussoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerListar>>> = ({ signal }) => discussoesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerListar>>>
export type DiscussoesControllerListarQueryError = unknown


export function useDiscussoesControllerListar<TData = Awaited<ReturnType<typeof discussoesControllerListar>>, TError = unknown>(
 params: undefined |  DiscussoesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerListar<TData = Awaited<ReturnType<typeof discussoesControllerListar>>, TError = unknown>(
 params?: DiscussoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerListar<TData = Awaited<ReturnType<typeof discussoesControllerListar>>, TError = unknown>(
 params?: DiscussoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as discussões do próprio ambiente
 */

export function useDiscussoesControllerListar<TData = Awaited<ReturnType<typeof discussoesControllerListar>>, TError = unknown>(
 params?: DiscussoesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerCriarRascunhoUrl = () => {




  return `/v1/discussoes/rascunhos`
}

/**
 * @summary Cria o rascunho INCREMENTAL do wizard web, na transição do passo "Assunto" pro passo "Exames a compartilhar" — ainda sem advisor escolhido. Ver PATCH .../rascunhos/:id para os passos seguintes.
 */
export const discussoesControllerCriarRascunho = async (criarRascunhoDiscussaoDto: CriarRascunhoDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<RascunhoDiscussaoResponse> => {

  return httpClient<RascunhoDiscussaoResponse>(getDiscussoesControllerCriarRascunhoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarRascunhoDiscussaoDto)
  }
);}





export const getDiscussoesControllerCriarRascunhoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerCriarRascunho>>, TError,{data: CriarRascunhoDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerCriarRascunho>>, TError,{data: CriarRascunhoDiscussaoDto}, TContext> => {

const mutationKey = ['discussoesControllerCriarRascunho'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerCriarRascunho>>, {data: CriarRascunhoDiscussaoDto}> = (props) => {
          const {data} = props ?? {};

          return  discussoesControllerCriarRascunho(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerCriarRascunhoMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerCriarRascunho>>>
    export type DiscussoesControllerCriarRascunhoMutationBody = CriarRascunhoDiscussaoDto
    export type DiscussoesControllerCriarRascunhoMutationError = ErroResponse

    /**
 * @summary Cria o rascunho INCREMENTAL do wizard web, na transição do passo "Assunto" pro passo "Exames a compartilhar" — ainda sem advisor escolhido. Ver PATCH .../rascunhos/:id para os passos seguintes.
 */
export const useDiscussoesControllerCriarRascunho = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerCriarRascunho>>, TError,{data: CriarRascunhoDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerCriarRascunho>>,
        TError,
        {data: CriarRascunhoDiscussaoDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerCriarRascunhoMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerAtualizarRascunhoUrl = (id: string,) => {




  return `/v1/discussoes/rascunhos/${id}`
}

/**
 * @summary Salva o passo do wizard web sendo deixado — um PATCH por avanço (ou volta+edição)
 */
export const discussoesControllerAtualizarRascunho = async (id: string,
    atualizarRascunhoDiscussaoDto: AtualizarRascunhoDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<RascunhoDiscussaoResponse> => {

  return httpClient<RascunhoDiscussaoResponse>(getDiscussoesControllerAtualizarRascunhoUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarRascunhoDiscussaoDto)
  }
);}





export const getDiscussoesControllerAtualizarRascunhoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAtualizarRascunho>>, TError,{id: string;data: AtualizarRascunhoDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAtualizarRascunho>>, TError,{id: string;data: AtualizarRascunhoDiscussaoDto}, TContext> => {

const mutationKey = ['discussoesControllerAtualizarRascunho'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerAtualizarRascunho>>, {id: string;data: AtualizarRascunhoDiscussaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  discussoesControllerAtualizarRascunho(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerAtualizarRascunhoMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerAtualizarRascunho>>>
    export type DiscussoesControllerAtualizarRascunhoMutationBody = AtualizarRascunhoDiscussaoDto
    export type DiscussoesControllerAtualizarRascunhoMutationError = ErroResponse

    /**
 * @summary Salva o passo do wizard web sendo deixado — um PATCH por avanço (ou volta+edição)
 */
export const useDiscussoesControllerAtualizarRascunho = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAtualizarRascunho>>, TError,{id: string;data: AtualizarRascunhoDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerAtualizarRascunho>>,
        TError,
        {id: string;data: AtualizarRascunhoDiscussaoDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerAtualizarRascunhoMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerObterRascunhoUrl = (id: string,) => {




  return `/v1/discussoes/rascunhos/${id}`
}

/**
 * @summary Estado salvo do rascunho, para retomar o wizard web de onde parou
 */
export const discussoesControllerObterRascunho = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<RascunhoDiscussaoResponse> => {

  return httpClient<RascunhoDiscussaoResponse>(getDiscussoesControllerObterRascunhoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterRascunhoQueryKey = (id: string,) => {
    return [
    `/v1/discussoes/rascunhos/${id}`
    ] as const;
    }


export const getDiscussoesControllerObterRascunhoQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterRascunhoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>> = ({ signal }) => discussoesControllerObterRascunho(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterRascunhoQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>>
export type DiscussoesControllerObterRascunhoQueryError = ErroResponse


export function useDiscussoesControllerObterRascunho<TData = Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterRascunho>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterRascunho>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterRascunho<TData = Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterRascunho>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterRascunho>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterRascunho<TData = Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Estado salvo do rascunho, para retomar o wizard web de onde parou
 */

export function useDiscussoesControllerObterRascunho<TData = Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterRascunho>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterRascunhoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerDetalharUrl = (id: string,) => {




  return `/v1/discussoes/${id}`
}

/**
 * @summary Detalha a discussão
 */
export const discussoesControllerDetalhar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<DiscussaoResponse> => {

  return httpClient<DiscussaoResponse>(getDiscussoesControllerDetalharUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerDetalharQueryKey = (id: string,) => {
    return [
    `/v1/discussoes/${id}`
    ] as const;
    }


export const getDiscussoesControllerDetalharQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerDetalharQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerDetalhar>>> = ({ signal }) => discussoesControllerDetalhar(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerDetalharQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerDetalhar>>>
export type DiscussoesControllerDetalharQueryError = ErroResponse


export function useDiscussoesControllerDetalhar<TData = Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerDetalhar<TData = Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerDetalhar<TData = Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha a discussão
 */

export function useDiscussoesControllerDetalhar<TData = Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerDetalharQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerObterPacienteDaDiscussaoUrl = (id: string,) => {




  return `/v1/discussoes/${id}/paciente`
}

/**
 * @summary Ficha do paciente vinculado — só quem participa da discussão vê
 */
export const discussoesControllerObterPacienteDaDiscussao = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<PacienteDaDiscussaoResponse> => {

  return httpClient<PacienteDaDiscussaoResponse>(getDiscussoesControllerObterPacienteDaDiscussaoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterPacienteDaDiscussaoQueryKey = (id: string,) => {
    return [
    `/v1/discussoes/${id}/paciente`
    ] as const;
    }


export const getDiscussoesControllerObterPacienteDaDiscussaoQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterPacienteDaDiscussaoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>> = ({ signal }) => discussoesControllerObterPacienteDaDiscussao(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterPacienteDaDiscussaoQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>>
export type DiscussoesControllerObterPacienteDaDiscussaoQueryError = ErroResponse


export function useDiscussoesControllerObterPacienteDaDiscussao<TData = Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterPacienteDaDiscussao<TData = Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterPacienteDaDiscussao<TData = Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ficha do paciente vinculado — só quem participa da discussão vê
 */

export function useDiscussoesControllerObterPacienteDaDiscussao<TData = Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterPacienteDaDiscussao>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterPacienteDaDiscussaoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerObterResumoDoHistoricoUrl = (id: string,) => {




  return `/v1/discussoes/${id}/paciente/historico`
}

/**
 * @summary Resumo do histórico clínico do paciente vinculado — só quem participa da discussão vê. É o mesmo cabeçalho que o médico vê em /historico, liberado ao advisor pela participação, não pelo tenant.
 */
export const discussoesControllerObterResumoDoHistorico = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ResumoDoHistoricoResponse> => {

  return httpClient<ResumoDoHistoricoResponse>(getDiscussoesControllerObterResumoDoHistoricoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterResumoDoHistoricoQueryKey = (id: string,) => {
    return [
    `/v1/discussoes/${id}/paciente/historico`
    ] as const;
    }


export const getDiscussoesControllerObterResumoDoHistoricoQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterResumoDoHistoricoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>> = ({ signal }) => discussoesControllerObterResumoDoHistorico(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterResumoDoHistoricoQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>>
export type DiscussoesControllerObterResumoDoHistoricoQueryError = ErroResponse


export function useDiscussoesControllerObterResumoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterResumoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterResumoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resumo do histórico clínico do paciente vinculado — só quem participa da discussão vê. É o mesmo cabeçalho que o médico vê em /historico, liberado ao advisor pela participação, não pelo tenant.
 */

export function useDiscussoesControllerObterResumoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterResumoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterResumoDoHistoricoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerObterLinhaDoTempoDoHistoricoUrl = (id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/discussoes/${id}/paciente/historico/linha-do-tempo?${stringifiedParams}` : `/v1/discussoes/${id}/paciente/historico/linha-do-tempo`
}

/**
 * @summary Linha do tempo (exames, prontuários, requisições, receituários) do paciente vinculado
 */
export const discussoesControllerObterLinhaDoTempoDoHistorico = async (id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams, options?: Parameters<typeof httpClient>[1]): Promise<LinhaDoTempoResponse> => {

  return httpClient<LinhaDoTempoResponse>(getDiscussoesControllerObterLinhaDoTempoDoHistoricoUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterLinhaDoTempoDoHistoricoQueryKey = (id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams,) => {
    return [
    `/v1/discussoes/${id}/paciente/historico/linha-do-tempo`, ...(params ? [params] : [])
    ] as const;
    }


export const getDiscussoesControllerObterLinhaDoTempoDoHistoricoQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError = ErroResponse>(id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterLinhaDoTempoDoHistoricoQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>> = ({ signal }) => discussoesControllerObterLinhaDoTempoDoHistorico(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterLinhaDoTempoDoHistoricoQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>>
export type DiscussoesControllerObterLinhaDoTempoDoHistoricoQueryError = ErroResponse


export function useDiscussoesControllerObterLinhaDoTempoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError = ErroResponse>(
 id: string,
    params: undefined |  DiscussoesControllerObterLinhaDoTempoDoHistoricoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterLinhaDoTempoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError = ErroResponse>(
 id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterLinhaDoTempoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError = ErroResponse>(
 id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Linha do tempo (exames, prontuários, requisições, receituários) do paciente vinculado
 */

export function useDiscussoesControllerObterLinhaDoTempoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError = ErroResponse>(
 id: string,
    params?: DiscussoesControllerObterLinhaDoTempoDoHistoricoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterLinhaDoTempoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterLinhaDoTempoDoHistoricoQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerObterSerieDoAnalitoDoHistoricoUrl = (id: string,
    analitoId: string,) => {




  return `/v1/discussoes/${id}/paciente/historico/analitos/${analitoId}`
}

/**
 * @summary Série de um analito do paciente vinculado — gráfico de evolução
 */
export const discussoesControllerObterSerieDoAnalitoDoHistorico = async (id: string,
    analitoId: string, options?: Parameters<typeof httpClient>[1]): Promise<SerieDoAnalitoResponse> => {

  return httpClient<SerieDoAnalitoResponse>(getDiscussoesControllerObterSerieDoAnalitoDoHistoricoUrl(id,analitoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterSerieDoAnalitoDoHistoricoQueryKey = (id: string,
    analitoId: string,) => {
    return [
    `/v1/discussoes/${id}/paciente/historico/analitos/${analitoId}`
    ] as const;
    }


export const getDiscussoesControllerObterSerieDoAnalitoDoHistoricoQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError = ErroResponse>(id: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterSerieDoAnalitoDoHistoricoQueryKey(id,analitoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>> = ({ signal }) => discussoesControllerObterSerieDoAnalitoDoHistorico(id,analitoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && analitoId !== null && analitoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterSerieDoAnalitoDoHistoricoQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>>
export type DiscussoesControllerObterSerieDoAnalitoDoHistoricoQueryError = ErroResponse


export function useDiscussoesControllerObterSerieDoAnalitoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError = ErroResponse>(
 id: string,
    analitoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterSerieDoAnalitoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError = ErroResponse>(
 id: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterSerieDoAnalitoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError = ErroResponse>(
 id: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Série de um analito do paciente vinculado — gráfico de evolução
 */

export function useDiscussoesControllerObterSerieDoAnalitoDoHistorico<TData = Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError = ErroResponse>(
 id: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterSerieDoAnalitoDoHistorico>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterSerieDoAnalitoDoHistoricoQueryOptions(id,analitoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerListarMensagensUrl = (id: string,
    params?: DiscussoesControllerListarMensagensParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/discussoes/${id}/mensagens?${stringifiedParams}` : `/v1/discussoes/${id}/mensagens`
}

/**
 * @summary Lista as mensagens da discussão, mais antiga primeiro
 */
export const discussoesControllerListarMensagens = async (id: string,
    params?: DiscussoesControllerListarMensagensParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeMensagensResponse> => {

  return httpClient<PaginaDeMensagensResponse>(getDiscussoesControllerListarMensagensUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerListarMensagensQueryKey = (id: string,
    params?: DiscussoesControllerListarMensagensParams,) => {
    return [
    `/v1/discussoes/${id}/mensagens`, ...(params ? [params] : [])
    ] as const;
    }


export const getDiscussoesControllerListarMensagensQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError = unknown>(id: string,
    params?: DiscussoesControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerListarMensagensQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>> = ({ signal }) => discussoesControllerListarMensagens(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerListarMensagensQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>>
export type DiscussoesControllerListarMensagensQueryError = unknown


export function useDiscussoesControllerListarMensagens<TData = Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError = unknown>(
 id: string,
    params: undefined |  DiscussoesControllerListarMensagensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerListarMensagens>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerListarMensagens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerListarMensagens<TData = Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: DiscussoesControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerListarMensagens>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerListarMensagens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerListarMensagens<TData = Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: DiscussoesControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as mensagens da discussão, mais antiga primeiro
 */

export function useDiscussoesControllerListarMensagens<TData = Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: DiscussoesControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerListarMensagensQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerEnviarMensagemUrl = (id: string,) => {




  return `/v1/discussoes/${id}/mensagens`
}

/**
 * @summary Envia uma mensagem. Idempotente por `clientMsgId`.
 */
export const discussoesControllerEnviarMensagem = async (id: string,
    enviarMensagemDto: EnviarMensagemDto, options?: Parameters<typeof httpClient>[1]): Promise<MensagemResponse> => {

  return httpClient<MensagemResponse>(getDiscussoesControllerEnviarMensagemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enviarMensagemDto)
  }
);}





export const getDiscussoesControllerEnviarMensagemMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemDto}, TContext> => {

const mutationKey = ['discussoesControllerEnviarMensagem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerEnviarMensagem>>, {id: string;data: EnviarMensagemDto}> = (props) => {
          const {id,data} = props ?? {};

          return  discussoesControllerEnviarMensagem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerEnviarMensagemMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerEnviarMensagem>>>
    export type DiscussoesControllerEnviarMensagemMutationBody = EnviarMensagemDto
    export type DiscussoesControllerEnviarMensagemMutationError = ErroResponse

    /**
 * @summary Envia uma mensagem. Idempotente por `clientMsgId`.
 */
export const useDiscussoesControllerEnviarMensagem = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerEnviarMensagem>>,
        TError,
        {id: string;data: EnviarMensagemDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerEnviarMensagemMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerGerarResumoUrl = (id: string,) => {




  return `/v1/discussoes/${id}/resumo`
}

/**
 * @summary Resumo estruturado do histórico via IA — organização da informação, nunca diagnóstico ou conduta
 */
export const discussoesControllerGerarResumo = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ResumoDaDiscussaoResponse> => {

  return httpClient<ResumoDaDiscussaoResponse>(getDiscussoesControllerGerarResumoUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDiscussoesControllerGerarResumoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerGerarResumo>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerGerarResumo>>, TError,{id: string}, TContext> => {

const mutationKey = ['discussoesControllerGerarResumo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerGerarResumo>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  discussoesControllerGerarResumo(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerGerarResumoMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerGerarResumo>>>

    export type DiscussoesControllerGerarResumoMutationError = ErroResponse

    /**
 * @summary Resumo estruturado do histórico via IA — organização da informação, nunca diagnóstico ou conduta
 */
export const useDiscussoesControllerGerarResumo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerGerarResumo>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerGerarResumo>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDiscussoesControllerGerarResumoMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerObterArquivoDaMensagemUrl = (id: string,
    mensagemId: string,) => {




  return `/v1/discussoes/${id}/mensagens/${mensagemId}/arquivo`
}

/**
 * @summary URL assinada do anexo de uma mensagem
 */
export const discussoesControllerObterArquivoDaMensagem = async (id: string,
    mensagemId: string, options?: Parameters<typeof httpClient>[1]): Promise<UrlDoArquivoResponse> => {

  return httpClient<UrlDoArquivoResponse>(getDiscussoesControllerObterArquivoDaMensagemUrl(id,mensagemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscussoesControllerObterArquivoDaMensagemQueryKey = (id: string,
    mensagemId: string,) => {
    return [
    `/v1/discussoes/${id}/mensagens/${mensagemId}/arquivo`
    ] as const;
    }


export const getDiscussoesControllerObterArquivoDaMensagemQueryOptions = <TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError = ErroResponse>(id: string,
    mensagemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscussoesControllerObterArquivoDaMensagemQueryKey(id,mensagemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>> = ({ signal }) => discussoesControllerObterArquivoDaMensagem(id,mensagemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && mensagemId !== null && mensagemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiscussoesControllerObterArquivoDaMensagemQueryResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>>
export type DiscussoesControllerObterArquivoDaMensagemQueryError = ErroResponse


export function useDiscussoesControllerObterArquivoDaMensagem<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError = ErroResponse>(
 id: string,
    mensagemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterArquivoDaMensagem<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError = ErroResponse>(
 id: string,
    mensagemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>,
          TError,
          Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiscussoesControllerObterArquivoDaMensagem<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError = ErroResponse>(
 id: string,
    mensagemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary URL assinada do anexo de uma mensagem
 */

export function useDiscussoesControllerObterArquivoDaMensagem<TData = Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError = ErroResponse>(
 id: string,
    mensagemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discussoesControllerObterArquivoDaMensagem>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiscussoesControllerObterArquivoDaMensagemQueryOptions(id,mensagemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiscussoesControllerMelhorarTextoUrl = (id: string,) => {




  return `/v1/discussoes/${id}/mensagens/melhorar-texto`
}

/**
 * @summary Revisão de português do rascunho, via IA — não altera nem envia a mensagem
 */
export const discussoesControllerMelhorarTexto = async (id: string,
    melhorarTextoDto: MelhorarTextoDto, options?: Parameters<typeof httpClient>[1]): Promise<TextoMelhoradoResponse> => {

  return httpClient<TextoMelhoradoResponse>(getDiscussoesControllerMelhorarTextoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(melhorarTextoDto)
  }
);}





export const getDiscussoesControllerMelhorarTextoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerMelhorarTexto>>, TError,{id: string;data: MelhorarTextoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerMelhorarTexto>>, TError,{id: string;data: MelhorarTextoDto}, TContext> => {

const mutationKey = ['discussoesControllerMelhorarTexto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerMelhorarTexto>>, {id: string;data: MelhorarTextoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  discussoesControllerMelhorarTexto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerMelhorarTextoMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerMelhorarTexto>>>
    export type DiscussoesControllerMelhorarTextoMutationBody = MelhorarTextoDto
    export type DiscussoesControllerMelhorarTextoMutationError = ErroResponse

    /**
 * @summary Revisão de português do rascunho, via IA — não altera nem envia a mensagem
 */
export const useDiscussoesControllerMelhorarTexto = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerMelhorarTexto>>, TError,{id: string;data: MelhorarTextoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerMelhorarTexto>>,
        TError,
        {id: string;data: MelhorarTextoDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerMelhorarTextoMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerEnviarMensagemDeVozUrl = (id: string,) => {




  return `/v1/discussoes/${id}/mensagens/voz`
}

/**
 * @summary Envia uma mensagem de VOZ: o áudio fica salvo na conversa e é transcrito por IA. Se a transcrição falhar a mensagem é enviada mesmo assim, com `voz.transcricaoStatus = FALHOU`. Idempotente por `clientMsgId`.
 */
export const discussoesControllerEnviarMensagemDeVoz = async (id: string,
    discussoesControllerEnviarMensagemDeVozBody: DiscussoesControllerEnviarMensagemDeVozBody, options?: Parameters<typeof httpClient>[1]): Promise<MensagemResponse> => {
    const formData = new FormData();
formData.append(`audio`, discussoesControllerEnviarMensagemDeVozBody.audio);
formData.append(`clientMsgId`, discussoesControllerEnviarMensagemDeVozBody.clientMsgId);
formData.append(`duracaoSegundos`, discussoesControllerEnviarMensagemDeVozBody.duracaoSegundos.toString())

  return httpClient<MensagemResponse>(getDiscussoesControllerEnviarMensagemDeVozUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getDiscussoesControllerEnviarMensagemDeVozMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarMensagemDeVoz>>, TError,{id: string;data: DiscussoesControllerEnviarMensagemDeVozBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarMensagemDeVoz>>, TError,{id: string;data: DiscussoesControllerEnviarMensagemDeVozBody}, TContext> => {

const mutationKey = ['discussoesControllerEnviarMensagemDeVoz'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerEnviarMensagemDeVoz>>, {id: string;data: DiscussoesControllerEnviarMensagemDeVozBody}> = (props) => {
          const {id,data} = props ?? {};

          return  discussoesControllerEnviarMensagemDeVoz(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerEnviarMensagemDeVozMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerEnviarMensagemDeVoz>>>
    export type DiscussoesControllerEnviarMensagemDeVozMutationBody = DiscussoesControllerEnviarMensagemDeVozBody
    export type DiscussoesControllerEnviarMensagemDeVozMutationError = ErroResponse

    /**
 * @summary Envia uma mensagem de VOZ: o áudio fica salvo na conversa e é transcrito por IA. Se a transcrição falhar a mensagem é enviada mesmo assim, com `voz.transcricaoStatus = FALHOU`. Idempotente por `clientMsgId`.
 */
export const useDiscussoesControllerEnviarMensagemDeVoz = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEnviarMensagemDeVoz>>, TError,{id: string;data: DiscussoesControllerEnviarMensagemDeVozBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerEnviarMensagemDeVoz>>,
        TError,
        {id: string;data: DiscussoesControllerEnviarMensagemDeVozBody},
        TContext
      > => {
      return useMutation(getDiscussoesControllerEnviarMensagemDeVozMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerRetranscreverMensagemDeVozUrl = (id: string,
    mensagemId: string,) => {




  return `/v1/discussoes/${id}/mensagens/${mensagemId}/transcrever`
}

/**
 * @summary Transcreve de novo uma mensagem de voz cuja transcrição falhou no envio. Já transcrita: devolve como está.
 */
export const discussoesControllerRetranscreverMensagemDeVoz = async (id: string,
    mensagemId: string, options?: Parameters<typeof httpClient>[1]): Promise<MensagemResponse> => {

  return httpClient<MensagemResponse>(getDiscussoesControllerRetranscreverMensagemDeVozUrl(id,mensagemId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDiscussoesControllerRetranscreverMensagemDeVozMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerRetranscreverMensagemDeVoz>>, TError,{id: string;mensagemId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerRetranscreverMensagemDeVoz>>, TError,{id: string;mensagemId: string}, TContext> => {

const mutationKey = ['discussoesControllerRetranscreverMensagemDeVoz'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerRetranscreverMensagemDeVoz>>, {id: string;mensagemId: string}> = (props) => {
          const {id,mensagemId} = props ?? {};

          return  discussoesControllerRetranscreverMensagemDeVoz(id,mensagemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerRetranscreverMensagemDeVozMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerRetranscreverMensagemDeVoz>>>

    export type DiscussoesControllerRetranscreverMensagemDeVozMutationError = ErroResponse

    /**
 * @summary Transcreve de novo uma mensagem de voz cuja transcrição falhou no envio. Já transcrita: devolve como está.
 */
export const useDiscussoesControllerRetranscreverMensagemDeVoz = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerRetranscreverMensagemDeVoz>>, TError,{id: string;mensagemId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerRetranscreverMensagemDeVoz>>,
        TError,
        {id: string;mensagemId: string},
        TContext
      > => {
      return useMutation(getDiscussoesControllerRetranscreverMensagemDeVozMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerMarcarComoLidaUrl = (id: string,) => {




  return `/v1/discussoes/${id}/leitura`
}

/**
 * @summary Marca a discussão como lida até agora
 */
export const discussoesControllerMarcarComoLida = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getDiscussoesControllerMarcarComoLidaUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDiscussoesControllerMarcarComoLidaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerMarcarComoLida>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerMarcarComoLida>>, TError,{id: string}, TContext> => {

const mutationKey = ['discussoesControllerMarcarComoLida'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerMarcarComoLida>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  discussoesControllerMarcarComoLida(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerMarcarComoLidaMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerMarcarComoLida>>>

    export type DiscussoesControllerMarcarComoLidaMutationError = unknown

    /**
 * @summary Marca a discussão como lida até agora
 */
export const useDiscussoesControllerMarcarComoLida = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerMarcarComoLida>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerMarcarComoLida>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDiscussoesControllerMarcarComoLidaMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerEncerrarUrl = (id: string,) => {




  return `/v1/discussoes/${id}/encerrar`
}

/**
 * @summary Encerra a discussão manualmente e antecipadamente — só o médico autor
 */
export const discussoesControllerEncerrar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<DiscussaoResponse> => {

  return httpClient<DiscussaoResponse>(getDiscussoesControllerEncerrarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDiscussoesControllerEncerrarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEncerrar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEncerrar>>, TError,{id: string}, TContext> => {

const mutationKey = ['discussoesControllerEncerrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerEncerrar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  discussoesControllerEncerrar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerEncerrarMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerEncerrar>>>

    export type DiscussoesControllerEncerrarMutationError = ErroResponse

    /**
 * @summary Encerra a discussão manualmente e antecipadamente — só o médico autor
 */
export const useDiscussoesControllerEncerrar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerEncerrar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerEncerrar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDiscussoesControllerEncerrarMutationOptions(options), queryClient);
    }
    export const getDiscussoesControllerAvaliarUrl = (id: string,) => {




  return `/v1/discussoes/${id}/avaliacao`
}

/**
 * @summary Avalia o atendimento. Só o autor, só depois de encerrada, uma vez.
 */
export const discussoesControllerAvaliar = async (id: string,
    avaliarDiscussaoDto: AvaliarDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<DiscussaoResponse> => {

  return httpClient<DiscussaoResponse>(getDiscussoesControllerAvaliarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(avaliarDiscussaoDto)
  }
);}





export const getDiscussoesControllerAvaliarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAvaliar>>, TError,{id: string;data: AvaliarDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAvaliar>>, TError,{id: string;data: AvaliarDiscussaoDto}, TContext> => {

const mutationKey = ['discussoesControllerAvaliar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discussoesControllerAvaliar>>, {id: string;data: AvaliarDiscussaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  discussoesControllerAvaliar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscussoesControllerAvaliarMutationResult = NonNullable<Awaited<ReturnType<typeof discussoesControllerAvaliar>>>
    export type DiscussoesControllerAvaliarMutationBody = AvaliarDiscussaoDto
    export type DiscussoesControllerAvaliarMutationError = ErroResponse

    /**
 * @summary Avalia o atendimento. Só o autor, só depois de encerrada, uma vez.
 */
export const useDiscussoesControllerAvaliar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discussoesControllerAvaliar>>, TError,{id: string;data: AvaliarDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discussoesControllerAvaliar>>,
        TError,
        {id: string;data: AvaliarDiscussaoDto},
        TContext
      > => {
      return useMutation(getDiscussoesControllerAvaliarMutationOptions(options), queryClient);
    }
    export const getArtigosDaDiscussaoControllerListarUrl = (id: string,) => {




  return `/v1/discussoes/${id}/artigos-do-assessor`
}

/**
 * @summary Artigos publicados do advisor desta discussão
 */
export const artigosDaDiscussaoControllerListar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeArtigosResponse> => {

  return httpClient<ListaDeArtigosResponse>(getArtigosDaDiscussaoControllerListarUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getArtigosDaDiscussaoControllerListarQueryKey = (id: string,) => {
    return [
    `/v1/discussoes/${id}/artigos-do-assessor`
    ] as const;
    }


export const getArtigosDaDiscussaoControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArtigosDaDiscussaoControllerListarQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>> = ({ signal }) => artigosDaDiscussaoControllerListar(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ArtigosDaDiscussaoControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>>
export type ArtigosDaDiscussaoControllerListarQueryError = ErroResponse


export function useArtigosDaDiscussaoControllerListar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>,
          TError,
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosDaDiscussaoControllerListar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>,
          TError,
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosDaDiscussaoControllerListar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Artigos publicados do advisor desta discussão
 */

export function useArtigosDaDiscussaoControllerListar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getArtigosDaDiscussaoControllerListarQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getArtigosDaDiscussaoControllerDetalharUrl = (id: string,
    artigoId: string,) => {




  return `/v1/discussoes/${id}/artigos-do-assessor/${artigoId}`
}

/**
 * @summary Artigo completo, para o pop-up da discussão
 */
export const artigosDaDiscussaoControllerDetalhar = async (id: string,
    artigoId: string, options?: Parameters<typeof httpClient>[1]): Promise<ArtigoResponse> => {

  return httpClient<ArtigoResponse>(getArtigosDaDiscussaoControllerDetalharUrl(id,artigoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getArtigosDaDiscussaoControllerDetalharQueryKey = (id: string,
    artigoId: string,) => {
    return [
    `/v1/discussoes/${id}/artigos-do-assessor/${artigoId}`
    ] as const;
    }


export const getArtigosDaDiscussaoControllerDetalharQueryOptions = <TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError = ErroResponse>(id: string,
    artigoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArtigosDaDiscussaoControllerDetalharQueryKey(id,artigoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>> = ({ signal }) => artigosDaDiscussaoControllerDetalhar(id,artigoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && artigoId !== null && artigoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ArtigosDaDiscussaoControllerDetalharQueryResult = NonNullable<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>>
export type ArtigosDaDiscussaoControllerDetalharQueryError = ErroResponse


export function useArtigosDaDiscussaoControllerDetalhar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError = ErroResponse>(
 id: string,
    artigoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosDaDiscussaoControllerDetalhar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError = ErroResponse>(
 id: string,
    artigoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosDaDiscussaoControllerDetalhar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError = ErroResponse>(
 id: string,
    artigoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Artigo completo, para o pop-up da discussão
 */

export function useArtigosDaDiscussaoControllerDetalhar<TData = Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError = ErroResponse>(
 id: string,
    artigoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosDaDiscussaoControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getArtigosDaDiscussaoControllerDetalharQueryOptions(id,artigoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






